import { render, staticRenderFns } from "./Sobt.vue?vue&type=template&id=77dd1cee&scoped=true&"
import script from "./Sobt.vue?vue&type=script&lang=js&"
export * from "./Sobt.vue?vue&type=script&lang=js&"
import style0 from "./Sobt.vue?vue&type=style&index=0&id=77dd1cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dd1cee",
  null
  
)

export default component.exports